"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ChartContext_1 = require("../../context/ChartContext");
const useXYReduce_1 = __importStar(require("../../hooks/useXYReduce"));
const PathBuilder_1 = require("../../utility/PathBuilder");
const scale_1 = require("../utilities/scale");
function usePath(spectrum, options) {
    const { width, horizontalMargin = 10 } = options;
    const scaleX = (0, scale_1.useScale2DY)();
    const scaleY = (0, scale_1.use1DTraceYScale)(spectrum.id, width, horizontalMargin);
    const xyReduce = (0, useXYReduce_1.default)(useXYReduce_1.XYReducerDomainAxis.YAxis);
    const { x, re: y } = spectrum.data;
    const pathPoints = xyReduce({ x, y });
    const pathBuilder = new PathBuilder_1.PathBuilder();
    pathBuilder.moveTo(scaleY(pathPoints.y.at(-1)), scaleX(pathPoints.x.at(-1)));
    for (let i = pathPoints.x.length - 2; i >= 0; i--) {
        pathBuilder.lineTo(scaleY(pathPoints.y[i]), scaleX(pathPoints.x[i]));
    }
    return pathBuilder.toString();
}
function Left1DChart({ horizontalMargin = 10, data: spectrum, }) {
    const { height, margin, displayerKey } = (0, ChartContext_1.useChartData)();
    const width = margin.left;
    const path = usePath(spectrum, { horizontalMargin, width });
    const innerHeight = height - margin.bottom - margin.top;
    if (!innerHeight || !width)
        return null;
    return ((0, jsx_runtime_1.jsxs)("svg", { viewBox: `0 0 ${width} ${innerHeight + margin.top}`, width: width, height: innerHeight + margin.top, children: [(0, jsx_runtime_1.jsx)("defs", { children: (0, jsx_runtime_1.jsx)("clipPath", { id: `${displayerKey}clip-left`, children: (0, jsx_runtime_1.jsx)("rect", { width: width, height: innerHeight, x: "0", y: margin.top }) }) }), (0, jsx_runtime_1.jsx)("g", { clipPath: `url(#${displayerKey}clip-left)`, children: (0, jsx_runtime_1.jsx)("path", { className: "line", stroke: spectrum.display.color, fill: "none", d: path }) })] }));
}
exports.default = (0, react_1.memo)(Left1DChart);
